import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import {
  GainCatalog,
  GainFormulaInstancesResponse,
  GainFormulaInstancesReadOnlyResponse,
} from '../models/gain-formula-instance.model';

@Injectable({
  providedIn: 'root',
})
export class GainFormulaInstanceService {
  constructor(private apiService: ApiService) {}

  getByRule(ruleUid: string): Observable<GainFormulaInstancesResponse> {
    return this.apiService.get<GainFormulaInstancesResponse>(
      `/GainFormulaInstance/GetByRule/${encodeURIComponent(ruleUid)}`,
    );
  }

  getByRuleReadOnly(
    ruleUid: string,
  ): Observable<GainFormulaInstancesReadOnlyResponse> {
    return this.apiService.get<GainFormulaInstancesReadOnlyResponse>(
      `/GainFormulaInstance/GetByRuleReadOnly/${encodeURIComponent(ruleUid)}`,
    );
  }

  getCatalog(): Observable<GainCatalog> {
    return this.apiService.get<GainCatalog>('/GainCatalog/Get/');
  }
}
